<template>
    <div class="pp-related" v-if="users.length">
        <div class="pp-related-title">
            <h5>{{word.see_more_like}} {{ userName }}</h5>
        </div>
        <div class="row">
            <div v-for="(user, index) in users" :key="index" class="col-md-4 col-sm-6">
                <a :href="'/'+$window.locale+'/user/' + user.user_name" style="display: block;">
                    <div class="pp-related-box">
                        <img :src="user.avatar" alt="">
                        <div class="pp-related-box-chat">
                            <h5 v-if="user.age">{{ user.name }}, {{user.age}}</h5>
                            <h5 v-else>{{ user.name }}</h5>
                            <div v-if="user.place" class="mb-2"> <i class="fas fa-map-marker-alt"> </i> {{user.place}} </div>
                            <create-chat :user="user"></create-chat>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div class="pp-related-btnSearch">
            <a class="btn btn-primary" :href="buildAllMatchesLink()">{{text.back_to_search_results}}</a>
        </div>
    </div>
</template>

<script>
    import CreateChat from "../chats/CreateChat";

    export default {
        name: "similar-users",

        components: {
            CreateChat
        },

        props: [
            'userId',
            'userName'
        ],

        data() {
            return {
                users: [],
                word: window.word,
                text: window.text,
            }
        },

        methods: {
            buildAllMatchesLink() {
                return `/${window.locale}/dashboard/matches`;
            },
            fetchUsers() {
                axios.get('/dashboard/user/' + this.userId + '/similar')
                    .then(response => this.users = response.data.data)
                    .catch(error => console.log(error));
            }
        },

        async mounted() {
            await this.fetchUsers();
        }
    }
</script>

<style scoped>

</style>
